import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { cities, experiences } from '../data';

const ExperienceBrowser = () => {
  const [selectedCity, setSelectedCity] = useState('All Cities');
  const [search, setSearch] = useState('');

  const filteredExperiences = useMemo(() => {
    const normalizedSearch = search.trim().toLowerCase();

    return experiences.filter((experience) => {
      const cityMatch =
        selectedCity === 'All Cities' ||
        experience.city === selectedCity;

      const searchableText = [
        experience.name,
        experience.city,
        experience.state,
        experience.category,
        experience.setting,
        experience.summary,
        ...(Array.isArray(experience.vibe) ? experience.vibe : []),
        ...(Array.isArray(experience.primaryCategories)
          ? experience.primaryCategories
          : []),
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      return cityMatch && searchableText.includes(normalizedSearch);
    });
  }, [selectedCity, search]);

  const getCityLabel = (city) => {
    if (city === 'Denver') {
      return 'Denver, CO';
    }

    if (city === 'Casper') {
      return 'Casper, WY';
    }

    return city;
  };

  return (
    <section className="experiences-section">
      <div className="section-heading split">
        <div>
          <p className="eyebrow">Browse All</p>
          <h2>Curated options for every kind of team.</h2>
        </div>

        <div className="filters">
          <select
            value={selectedCity}
            onChange={(event) => setSelectedCity(event.target.value)}
            aria-label="Filter experiences by city"
          >
            {cities.map((city) => (
              <option key={city} value={city}>
                {getCityLabel(city)}
              </option>
            ))}
          </select>

          <input
            type="search"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Search vibe, city, or activity"
            aria-label="Search experiences"
          />
        </div>
      </div>

  {filteredExperiences.length > 0 ? (
  <div className="experience-grid">
    {filteredExperiences.map((experience) => (
      <Link
        to={`/business/${experience.id}`}
        className="experience-card"
        key={experience.id}
      >
        <img
          src={experience.image}
          alt={experience.name}
        />

        <div className="card-body">
          <div className="card-meta">
            {experience.city}, {experience.state} · {experience.price}
          </div>

          <h3>{experience.name}</h3>

          <p>{experience.summary}</p>

          <div className="tag-row">
            <span>{experience.category}</span>
            <span>{experience.groupSize} people</span>
            <span>{experience.duration}</span>
          </div>
        </div>
      </Link>
    ))}
  </div>
) : (
  <div className="experience-grid">
    <div className="empty-results">
      <h2>No experiences match your current filters.</h2>

      <p>
       Try selecting another city or using a broader search term.
      </p>
    </div>
  </div>
      )}
    </section>
  );
};

export default ExperienceBrowser;
